/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { itemCountSchema } from './itemCountSchema';
import { progressTrendPointSchema } from './progressTrendPointSchema';

export const progressTrendsResponseSchema = z.object({
  completionRate: z.number().nullish(),
  forecastDaysToCompletion: z.int(),
  get itemCount() {
    return itemCountSchema;
  },
  ratesSinceDate: z.iso.date().nullish(),
  scopeGrowthRate: z.number().nullish(),
  targetDate: z.iso.date().nullish(),
  today: z.iso.date(),
  get trendDataPoints() {
    return z.array(progressTrendPointSchema);
  },
});
